import EmployeeWarningLetterComponent from "../components/EmployeeWarningLetter";
import useEmployeeWarningLetter from "../hooks/useEmployeeWarningLetter";

const EmployeeWarningLetter = () => {
    const EmployeeWaringLetterProps = useEmployeeWarningLetter();
    return <EmployeeWarningLetterComponent {...EmployeeWaringLetterProps} />;
};

export default EmployeeWarningLetter;
